class Content {
  constructor() {
    this.mailToLinks = document.querySelectorAll('a[href^=mailto]');
    this.linkedImages = document.querySelectorAll('a > img');

    if (this.mailToLinks && this.mailToLinks.length > 0) {
      this.mailtoWordBreak(this.mailToLinks);
    }

    if (this.linkedImages) {
      this.removeLinkBorder(this.linkedImages);
    }
  }

  /**
   * Inserts a word break element after the @ symbol in a mailto link
   * @param {nodeList} elementList
   */
  mailtoWordBreak(elementList) {
    for (let element of elementList) {
      // some links are inside collapsed areas where grabbing innerText returns empty
      // and don't want to override any inner spans required for other component formatting
      const spanLayer = element.querySelector('span');
      const rawText = spanLayer?.textContent?.trim() ?? element.textContent.trim();

      const formatted = rawText.replace(/([@.])/g, '<wbr>$1');
      if (!formatted) continue;

      if (spanLayer) {
        spanLayer.innerHTML = formatted;
      } else {
        element.innerHTML = formatted;
      }
    }
  }

  /**
   * For all the images nested inside of an anchor tag on the page,
   * applies the 'no-decoration' class to the anchor element so that linked images
   * do not show any of the plain text link styling
   *
   * @param {nodeList} elementList
   */
  removeLinkBorder(elementList) {
    elementList.forEach((element) => {
      let parentLink = element.parentElement;

      if (!parentLink.classList.contains('no-decoration')) {
        parentLink.classList.add('no-decoration');
      }
    });
  }
}

export default Content;
